import { useAuthStore } from '@/stores';
import { Button } from '@repo/ui';
import { createFileRoute, redirect, useNavigate, useSearch } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  // `/` is the login page, so only signed-in users are sent on; redirecting everyone
  // would loop with the `_authenticated` guard, which sends signed-out users back here.
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated) throw redirect({ to: '/customers' });
  },
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { redirect } = useSearch({ strict: false }) as { redirect?: string };
  const { isAuthenticated, setAuth } = useAuthStore();
  const handleSubmit = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    setAuth({ id: '1', email: 'test@gmail.com', name: 'Test User', role: 'admin' }, 'mock-token');
    void navigate({ to: redirect ?? '/customers' });
  };
  return (
    <div className="flex h-screen w-screen items-center justify-center" onClick={handleSubmit}>
      <Button className="bg-info-primary justify-center self-center text-white">
        {isAuthenticated ? 'Customers' : 'Authenticate'}
      </Button>
    </div>
  );
}
